import { salvarListagem } from "../infrastructure/persistence/listagem.storage";

const MUTACOES_OBSERVADAS = [
  "relatoOcorrencia/SET_FILTROS",
  "relatoOcorrencia/RESET_FILTROS",
  "relatoOcorrencia/SET_PAGINA_ATUAL",
  "relatoOcorrencia/SET_ITENS_POR_PAGINA",
  "relatoOcorrencia/RESET_PAGINACAO"
];

export default function createPersistRelatoListagemPlugin() {
  return store => {
    store.subscribe((mutation, state) => {
      if (!MUTACOES_OBSERVADAS.includes(mutation.type)) return;
      const listagem = state.relatoOcorrencia;
      if (!listagem) return;
      salvarListagem({
        paginaAtual: listagem.paginaAtual,
        itensPorPagina: listagem.itensPorPagina,
        filtros: listagem.filtros
      });
    });
  };
}
